import React from 'react';
import PropTypes from 'prop-types';

import styles, {
  arrowInsetPixels,
  arrowWidthPixels,
  arrowApex
} from './ToolTip.styles.js';
import { getPassthroughProps } from '../componentHelpers.js';

class ToolTip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      top: null,
      left: null
    };
  }

  calculatePosition = (toolTipElement) => {
    if (!toolTipElement) {
      return;
    }

    let {
      arrowEdge,
      arrowSide,
      region,
    } = this.props;

    let top = null;
    let left = null;

    let tooltipRectangle = toolTipElement.getBoundingClientRect();

    let shouldPointArrowAtCenterOfRegion = region.width <= arrowInsetPixels + arrowWidthPixels;
    if (shouldPointArrowAtCenterOfRegion) {
      let arrowAdjustment = 2 - arrowInsetPixels - ((arrowWidthPixels - region.width)/2);
      if (arrowSide === 'left') {
        left = Math.round(region.left + arrowAdjustment);
      } else {
        left = Math.round(region.right - tooltipRectangle.width - arrowAdjustment);
      }
    } else {
      if (arrowSide === 'left') {
        left = Math.round(region.left);
      } else {
        left = Math.round(region.right - tooltipRectangle.width);
      }
    }

    if (arrowEdge === 'bottom') {
      top = Math.round(region.top - tooltipRectangle.height) - (arrowWidthPixels/2);
    } else {
      top = Math.round(region.bottom + (arrowWidthPixels/2));
    }

    if (left !== this.state.left || top !== this.state.top) {
      this.setState({ top, left });
    }
  }

  render() {
    let {
      arrowEdge,
      arrowSide,
      children,
    } = this.props;
    let { state } = this;

    return (
      <div
        {...getPassthroughProps(this)}
        ref={this.calculatePosition}
        style={styles.container.calculate(state)}
      >
        <div
          style={styles.arrow.calculate(arrowEdge, arrowSide)}
        />
        <div style={styles.inner}>
          {children}
        </div>
      </div>
    );
  }
}

ToolTip.propTypes = {
  arrowEdge: PropTypes.string,
  arrowSide: PropTypes.string,
  region: PropTypes.shape({
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number,
    top: PropTypes.number,
    height: PropTypes.number,
    width: PropTypes.number,
  }),
};

ToolTip.defaultProps = {
  arrowEdge: 'top',
  arrowSide: 'right',
};

export default ToolTip;
